import { useState, useEffect } from "react";
import { PointColor } from "../types";

/** Палитра для раскраски КП на карте (циклически по hash id). Без привязки к статичным точкам. */
const BASE_PLATFORM_COLORS: PointColor[] = ["green", "red", "green", "red", "green", "orange"];
const AI_RED_INDICES = [0, 2];
const AI_ORANGE_INDICES = [5];

export function useMapFilters() {
    const [aiActive, setAiActive] = useState(false);
    const [criticalActive, setCriticalActive] = useState(false);
    const [currentColors, setCurrentColors] = useState<PointColor[]>(() => [...BASE_PLATFORM_COLORS]);

    useEffect(() => {
        const newColors = aiActive
            ? BASE_PLATFORM_COLORS.map((c, idx) => {
                  if (AI_RED_INDICES.includes(idx)) return "red";
                  if (AI_ORANGE_INDICES.includes(idx)) return "orange";
                  return c;
              })
            : [...BASE_PLATFORM_COLORS];

        setCurrentColors(newColors);
    }, [aiActive]);

    return {
        aiActive,
        criticalActive,
        currentColors,
        setAiActive,
        setCriticalActive
    };
}

